export default __webpack_public_path__ + "static/media/01.2-coopharma.ecda9c46.png";